import {Yii} from "libraries/interfaces/Yii";
import {Component, Input} from '@angular/core';
import {ISearchRequest, IQuantity} from 'libraries/service/resources/hotel/ISearchParameters';
import {GeopositionService} from "libraries/service/geoposition/geoposition.service";
import {IAfiGeoposition} from "libraries/service/geoposition/geoposition.model";
import {EStayPermissions} from "../../enums/e-stay-permissions";
import { IMomentDateFormat } from "libraries/interfaces/IMomentDateFormat";
import { IWenji } from "libraries/interfaces/IWenji";

declare const wenji: IWenji;

interface ITravellers {
    adult: {
        name: string;
        count: number;
    };
    child: {
        name: string;
        count: number;
    };
    infant: {
        name: string;
        count: number;
    };
    rooming: {
        pluralName?: string;
        name: string;
        count: number;
    };
}

@Component({
    selector: 'resume',
    templateUrl: './resume.component.html'
})
export class ResumeComponent {

    public dateFormat: IMomentDateFormat = JSON.parse(wenji.ui.dateFormat);

    @Input()
    public set resume(value: ISearchRequest) {
        if (value) {
            this.getTravellers(value.quantity);
        }

        this.resumeModel = value;
    }

    public get resume(): ISearchRequest {
        return this.resumeModel;
    }

    public travellers: ITravellers = {
        adult: {name: 'ADT', count: 1},
        child: {name: 'CHD', count: 0},
        infant: {name: 'INF', count: 0},
        rooming: {
            name: Yii.t('wui-shared-js', 'chambre'),
            pluralName: Yii.t('wui-shared-js', 'chambres'),
            count: 1
        }
    };
    public fakeLabel: string = Yii.t('wui-sasha-js', 'Pour forcer la génération de traduction');
    public labels: { [key: string]: string } = {
        Meter: Yii.t('wui-shared-js', 'Mètres'),
        location: Yii.t('wui-shared-js', 'Lieu'),
        latitude: Yii.t('wui-shared-js', 'Latitude'),
        longitude: Yii.t('wui-shared-js', 'Longitude'),
        geoposition: Yii.t('wui-shared-js', 'Géoposition'),
        radius: Yii.t('wui-shared-js', 'Radius'),
        hosts: Yii.t('wui-shared-js', 'Fournisseurs'),
        night: Yii.t('wui-shared-js', 'nuit'),
        nights: Yii.t('wui-shared-js', 'nuits'),
        isOnlyRefundable: Yii.t('wui-shared-js', 'Masquer les offres avec frais d\'annulation'),
    };

    public permissions: typeof EStayPermissions = EStayPermissions;

    private resumeModel: ISearchRequest;

    public constructor(
        private geopositionService: GeopositionService,
    ) {
    }

    public hasGeoposition(geoposition: IAfiGeoposition): boolean {
        return !this.geopositionService.isEmpty(geoposition);
    }

    private getTravellers(quantity: IQuantity): void {
        if (quantity) {
            this.travellers.adult.count = quantity.adult;
            this.travellers.child.count = quantity.child;
            this.travellers.infant.count = quantity.infant;
            this.travellers.rooming.count = quantity.rooming;
        }
    }
}
